import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import dayjs from 'dayjs';
import { BASE_URL } from "../config";
import authStorage from "../utils/authStorage";

// Garmin will not serve data recorded before a user connected unless they ticked
// "Historical Data" on the consent screen. That toggle defaults to OFF and the
// app cannot pre-select it, so a backfill for such a user fails with
// InvalidPullTokenException. Warn the admin before they spend a request on it.
const HISTORICAL_DATA_EXPORT = 'HISTORICAL_DATA_EXPORT';
const FITBIT_DEVICE_VALUE = '1';
const GARMIN_DEVICE_VALUE = '2';

const FetchDeviceData = ({ back }) => {
    const [devices, setDevices] = useState([]);
    const [users, setUsers] = useState([]);
    // Starts empty so the sequence begins at step 1. It used to default to "1"
    // (FitBit), which pre-completed a step the admin never consciously chose.
    const [selectedDevice, setSelectedDevice] = useState("");
    const [selectedUser, setSelectedUser] = useState('');
    const [fromDate, setFromDate] = useState('');
    const [toDate, setToDate] = useState('');
    const [error, setError] = useState('');
    const [msg,setMsg]=useState();
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
 useEffect(() => {
    let isAdmin = ["admin"].includes(authStorage.getItem("roles"));
    
    // If roles is not admin, redirect to dashboard page
    if (!isAdmin) {
      window.location = window.location.origin + "/membership";
      return false;
    }
  });
    const getUsersList = (event) => {
        setLoading(true);
        axios({
          headers: {
            "x-access-token": authStorage.getItem("auth-token"),
          },
          url: `${BASE_URL}/user/list`,
          method: "GET",
          // /user/list pages at 20 by default; this is a <select> that must show
          // the whole roster, so opt out of pagination explicitly.
          params: { limit: 0 },
        })
          .then((res) => {
            // This used to clear `loading` only on failure, so after a normal
            // load the flag stayed true for the life of the page.
            setLoading(false);
            setUsers(res?.data?.data?.data);
          })
          .catch((err) => {
            setLoading(false);
          });
      };
    
      useEffect(() => {
        getUsersList();
      }, []);
      // Only users actually connected to the selected device can be backfilled.
      // Listing everyone meant most options carried an empty id, so picking one
      // silently built a request against "" and fetched nothing.
      const deviceUsers = () => {
        if (!selectedDevice) {
            return [];
        }
        const idField = selectedDevice === FITBIT_DEVICE_VALUE ? 'fitBitId' : 'garminId';
        return (users || []).filter(u => u[idField]);
      };

      // The form is filled in order: device -> user -> from date -> to date.
      // Each step stays disabled until the one before it has a value.
      const canPickUser = Boolean(selectedDevice);
      const canPickFromDate = canPickUser && Boolean(selectedUser);
      const canPickToDate = canPickFromDate && Boolean(fromDate);
      const canSubmit = canPickToDate && Boolean(toDate) && !loading;

      const onDeviceChange = (value) => {
        setSelectedDevice(value);
        // fitBitId and garminId are different id spaces, so a user picked for the
        // old device is meaningless for the new one.
        setSelectedUser('');
      };

      // The <option> value is the user's garminId, so match on that. Returns
      // 'granted' | 'missing' | 'unknown' | null (nothing to say yet).
      const garminHistoricalState = () => {
        if (selectedDevice !== GARMIN_DEVICE_VALUE || !selectedUser) {
            return null;
        }
        const user = (users || []).find(u => u.garminId && u.garminId === selectedUser);
        if (!user) {
            return null;
        }
        // Absent means we have never read the permission set back from Garmin
        // for this user -- that is not the same as "they declined it".
        if (!Array.isArray(user.garminPermissions)) {
            return 'unknown';
        }
        return user.garminPermissions.includes(HISTORICAL_DATA_EXPORT) ? 'granted' : 'missing';
      };

      const selectedUserName = () => {
        const user = (users || []).find(u => u.garminId && u.garminId === selectedUser);
        return user ? `${user.firstName || ''} ${user.lastName || ''}`.trim() || 'This user' : 'This user';
      };

      const backFunction =async ()=>{
        navigate("/dashboard");
        back(2);
      }
      const handleSubmit = async (event) => {
        event.preventDefault();
        console.log("handle submit button call", selectedDevice, selectedUser, fromDate, toDate)
    
        if (!selectedDevice || !selectedUser  || !fromDate || !toDate) {
            setError("All fields are required.");
            setTimeout(() => setError(''), 5000);
            return;
        }
    
        let apiURl;
        if (selectedDevice === "1") {
            console.log("fitbit select 57")
            apiURl = `${BASE_URL}/fitbit/restore-fitbit-heart-rate/${selectedUser}/${fromDate}/${toDate}`;
        } else if (selectedDevice === "2") {
            apiURl = `${BASE_URL}/garmin/restore-garmin-heart-rate/${selectedUser}/${fromDate}/${toDate}`;
        } else {
            setError("Invalid device selected.");
            setTimeout(() => setError(''), 5000);
            return;
        }
    
        console.log("apiURl:", apiURl);

        // Also disables the button, so an impatient double-click cannot fire the
        // backfill twice.
        setLoading(true);

        try {
            const response = await axios.get(apiURl);
            console.log("Data Fetched Successfully", response.data);
            setLoading(false);
            if(response.data){

                setMsg(`Data Fetched Successfully ${response.data}`);
            }
            setTimeout(()=>{
                navigate("/dashboard")
                back(2);
            },2000)
            
            
        } catch (error) {
            console.error("Error fetching data", error);
            setError("Failed to fetch data");
            setLoading(false);
        }
    };

    return (
        <div className="bg-gray-200 h-screen p-10">
            <div className="m-auto rounded-lg p-8 bg-white shadow-lg">
                <div className="text-black text-xl px-4">Fetch Device Data</div>
                <form style={{ zIndex: '80000' }}  action="#" method="POST">
                    <div className="grid grid-cols-2 gap-4">
                        <div>
                            <label className="block text-gray-700">Select Device</label>
                            <select value={selectedDevice} onChange={(e) => onDeviceChange(e.target.value)} className="w-full p-2 border rounded">
                                <option value="">-- Select Device --</option>
                                <option value="1">FitBit</option>
                                <option value="2">Garmin</option>
                            </select>
                        </div>
                        <div>
                            <label className="block text-gray-700">Select User</label>
                            <select
                                value={selectedUser}
                                onChange={(e) => setSelectedUser(e.target.value)}
                                disabled={!canPickUser}
                                className="w-full p-2 border rounded disabled:bg-gray-100 disabled:text-gray-400 disabled:cursor-not-allowed"
                            >
                                <option value="">
                                    {canPickUser ? '-- Select User --' : '-- Select a device first --'}
                                </option>
                                {deviceUsers().map(user => (
                                    <option
                                        key={user._id}
                                        value={selectedDevice === FITBIT_DEVICE_VALUE ? user.fitBitId : user.garminId}
                                    >
                                        {user.firstName} {user.lastName}
                                    </option>
                                ))}
                            </select>
                            {canPickUser && deviceUsers().length === 0 && (
                                <p className="mt-1 text-xs text-gray-500">
                                    No users are connected to this device.
                                </p>
                            )}
                        </div>
                        <div>
                            <label className={canPickFromDate ? "block text-gray-700" : "block text-gray-400"}>From Date</label>
                            <input
                                type="date"
                                value={fromDate}
                                onChange={(e) => setFromDate(e.target.value)}
                                disabled={!canPickFromDate}
                                className="w-full p-2 border rounded disabled:bg-gray-100 disabled:text-gray-400 disabled:cursor-not-allowed"
                            />
                        </div>
                        <div>
                            <label className={canPickToDate ? "block text-gray-700" : "block text-gray-400"}>To Date</label>
                            <input
                                type="date"
                                value={toDate}
                                onChange={(e) => setToDate(e.target.value)}
                                disabled={!canPickToDate}
                                // Cannot end before it starts; the API takes the range verbatim.
                                min={fromDate || undefined}
                                className="w-full p-2 border rounded disabled:bg-gray-100 disabled:text-gray-400 disabled:cursor-not-allowed"
                            />
                        </div>
                    </div>
                    {garminHistoricalState() === 'missing' && (
                        <div className="mt-4 rounded border border-amber-300 bg-amber-50 p-3 text-sm text-amber-800">
                            <div className="font-medium">Historical Data is off for this Garmin user</div>
                            <p className="mt-1">
                                {selectedUserName()} did not enable <span className="font-medium">Historical Data</span> when
                                connecting Garmin, so Garmin will refuse to return anything recorded before they connected
                                and this backfill will fail. Ask them to open <span className="font-medium">Devices</span>,
                                reconnect Garmin, and switch <span className="font-medium">Historical Data</span> on — then
                                run this again.
                            </p>
                        </div>
                    )}
                    {garminHistoricalState() === 'unknown' && (
                        <div className="mt-4 rounded border border-gray-300 bg-gray-50 p-3 text-sm text-gray-700">
                            Historical Data permission is unknown for this user — it has not been read back from Garmin
                            since they connected. If this backfill returns no data, that permission is the first thing to check.
                        </div>
                    )}
                    {error && <div className="text-red-500 mt-2">{error}</div>}
                    <div className="mt-6 flex justify-end" >
                    <button
                        onClick={handleSubmit}
                        type="button"
                        disabled={!canSubmit}
                        className="button-theme font-medium rounded-lg text-sm px-5 py-2.5 text-center mr-2 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800 inline-flex items-center disabled:opacity-40 disabled:cursor-not-allowed"
                    >
                        Fetch Request
                    </button>
                    <button onClick={backFunction} type="button" className="button-theme font-medium rounded-lg text-sm px-5 py-2.5 text-center mr-2 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800 inline-flex items-center">
                      Go to Dashboard 
                    </button>
                    </div>
                </form>
                {msg && <h2>{msg}</h2>}
            </div>
        </div>
    );
};

export default FetchDeviceData;
